import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../constants/queryKeys";
import { callPublicAPI } from "../utils/api";

export const useFetchSelectedCategories = () => {
  return useQuery<string[]>({
    queryKey: [QUERY_KEYS.GET_USER_SELECTED_CATEGORY_IDS],
    queryFn: async () => {
      const searchParams = new URLSearchParams({
        limit: "100",
      });

      const response = await callPublicAPI<string[]>("GET", "/user-selected-categories", searchParams);
      return response.data;
    }
  });
}

